import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutContent from './components/AboutContent';
import SeoHead from '@/components/base/SeoHead';

export default function AboutPage() {
  const [scrolled, setScrolled] = useState(false);
  const { i18n } = useTranslation();
  const isTR = i18n.language === 'tr' || i18n.language?.startsWith('tr');

  const seo = isTR
    ? {
        title: 'Hakkımızda | OKAYISU LED Aydınlatma | 22 Yıllık Deneyim İstanbul',
        description: '2004ten beri İstanbulda LED aydınlatma proje tasarımı ve uygulamaları. 20den fazla ülkede 1000i aşkın tamamlanmış proje, mimari aydınlatma, endüstriyel LED çözümleri ve enerji optimizasyonu hizmetleri.',
        keywords: 'OKAYISU hakkımızda, LED aydınlatma firması İstanbul, mimari aydınlatma uzmanı, enerji verimliliği, profesyonel aydınlatma',
        canonicalUrl: 'https://www.okayisu.com/hakkimizda',
        lang: 'tr',
      }
    : {
        title: 'About OKAYISU | LED Lighting Project Design | 22 Years Istanbul',
        description: 'Since 2004, LED lighting project design and implementation in Istanbul. Over 1000 completed projects across 20+ countries. Architectural lighting, industrial LED solutions, and energy optimization services.',
        keywords: 'OKAYISU about us, LED lighting company Istanbul, architectural lighting expert, energy efficiency, professional lighting solutions',
        canonicalUrl: 'https://www.okayisu.com/en/hakkimizda',
        lang: 'en',
      };

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: isTR ? 'OKAYISU LED Aydınlatma Hakkımızda' : 'About OKAYISU LED Lighting',
    description: seo.description,
    url: seo.canonicalUrl,
    about: {
      '@type': 'Organization',
      name: 'OKAYISU Aydınlatma San. İç ve Dış Tic. Ltd. Şti.',
      foundingDate: '2004',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Perpa Ticaret Merkezi A Blok Kat:5 No:204',
        addressLocality: 'İstanbul',
        addressRegion: 'Şişli',
        postalCode: '34384',
        addressCountry: 'TR',
      },
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+90-212-220-52-56',
        email: 'info@okayisu.com',
        contactType: 'sales',
      },
    },
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-white min-h-screen">
      <SeoHead
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalUrl}
        lang={seo.lang}
        structuredData={structuredData}
      />
      <Navbar />
      <div className="pt-20">
        <AboutHero />
      </div>
      <AboutContent />
      <Footer />
    </div>
  );
}